var UnitKeys;
(function (UnitKeys) {
    UnitKeys["CO2_DISTANCE_RATIO"] = "co2DistanceRatioUnit";
    UnitKeys["DISTANCE"] = "distanceUnit";
    UnitKeys["FUEL"] = "fuelUnit";
    UnitKeys["FUEL_CONSUMPTION"] = "fuelConsumptionUnit";
    UnitKeys["SPEED"] = "speedUnit";
})(UnitKeys || (UnitKeys = {}));
export { UnitKeys };
